import styled from 'styled-components';

const SignInScreen = styled.main`
  --login-ink: #272B41;
  --login-muted: #868EAE;
  --login-accent: #5F63F2;
  min-height: 100vh;
  min-height: 100dvh;
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  background: #FFFFFF;
  font-family: 'Inter', sans-serif;
  .login-story {
    position: relative;
    overflow: hidden;
    padding: 44px 58px;
    background: #F4F5F7;
    color: #272B41;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
  }
  .login-story::before {
    content: '';
    position: absolute;
    width: 720px;
    height: 720px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(95, 99, 242, 0.08), transparent 66%);
    right: -300px;
    top: 0;
    pointer-events: none;
  }
  .login-story::after {
    content: '';
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(255, 255, 255, 1) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 1) 1px, transparent 1px);
    background-size: 64px 64px;
    pointer-events: none;
    mask-image: linear-gradient(transparent, #000);
  }
  .login-brand {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .login-brand img {
    width: 144px;
    height: 42px;
    object-fit: cover;
    object-position: center;
  }
  .login-brand span {
    border-left: 1px solid #E3E6EF;
    padding-left: 14px;
    color: #868EAE;
    font-size: 10px;
    letter-spacing: 1.6px;
    text-transform: uppercase;
  }
  .story-main {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 510px;
    margin: 48px auto;
  }
  .story-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
    color: #5F63F2;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 22px;
  }
  .story-eyebrow::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #5F63F2;
    box-shadow: 0 0 15px #5F63F240;
  }
  .story-main h1 {
    color: #272B41;
    font-size: clamp(34px, 3.3vw, 54px);
    font-weight: 500;
    line-height: 1.16;
    letter-spacing: -2px;
    margin: 0 0 22px;
  }
  .story-main h1 em {
    font-style: normal;
    color: #5F63F2;
  }
  .story-description {
    color: #5A5F7D;
    font-size: 14px;
    line-height: 1.9;
    max-width: 370px;
    margin-bottom: 38px;
  }
  .conversation-scene {
    position: relative;
    border: 1px solid rgba(227, 230, 239, 1);
    background: linear-gradient(135deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1));
    border-radius: 18px;
    box-shadow: 0 28px 60px rgba(39, 43, 65, 0.06);
    padding: 22px;
  }
  .scene-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 18px;
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(227, 230, 239, 1);
  }
  .scene-title {
    font-size: 12px;
    font-weight: 500;
    color: #272B41;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .scene-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: #5F63F212;
    color: #5F63F2;
  }
  .scene-dots {
    display: flex;
    gap: 4px;
  }
  .scene-dots i {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #868EAE;
  }
  .message-example {
    padding: 13px 16px;
    border-radius: 12px 12px 12px 2px;
    background: rgba(244, 245, 247, 1);
    color: #5A5F7D;
    font-size: 12px;
    line-height: 1.8;
    max-width: 85%;
  }
  .message-example.reply {
    margin: 14px 0 0 auto;
    background: #5F63F20D;
    border: 1px solid #5F63F226;
    border-radius: 12px 12px 2px 12px;
    color: #5A5F7D;
  }
  .scene-agent {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 7px;
    color: #5A5F7D;
    font-size: 10px;
  }
  .scene-agent .anticon {
    color: #4DA747;
  }
  .channel-tags {
    margin-top: 20px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
  .channel-tags span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #E3E6EF;
    padding: 6px 10px;
    border-radius: 7px;
    color: #5A5F7D;
    font-size: 10px;
  }
  .story-footer {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 10px;
    color: #868EAE;
    gap: 12px;
  }
  .story-footer span:last-child {
    color: #5A5F7D;
    display: flex;
    gap: 7px;
    align-items: center;
  }
  .login-panel {
    display: flex;
    flex-direction: column;
    padding: 38px 44px 24px;
    min-width: 0;
  }
  .login-topline {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    align-items: center;
    font-size: 12px;
    color: #868EAE;
  }
  .login-topline a {
    color: #5F63F2;
    font-weight: 600;
  }
  .login-form-area {
    width: 100%;
    max-width: 400px;
    margin: auto;
    padding: 50px 0;
  }
  .login-form-mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    background: #5F63F20D;
    border: 1px solid #E3E6EF;
    border-radius: 14px;
    color: #5F63F2;
    margin-bottom: 28px;
    font-size: 21px;
  }
  .login-form-area h2 {
    color: var(--login-ink);
    font-size: 36px;
    letter-spacing: -1.1px;
    font-weight: 600;
    margin: 0 0 10px;
    line-height: 1.3;
  }
  .login-form-description {
    margin: 0 0 34px;
    color: #868EAE;
    font-size: 13px;
    line-height: 1.8;
  }
  .ant-form-item {
    margin-bottom: 22px;
  }
  .ant-form-item-label {
    padding-bottom: 9px;
  }
  .ant-form-item-label > label {
    color: #5A5F7D;
    font-size: 12px;
    font-weight: 600;
  }
  .ant-form-item-required::before {
    display: none !important;
  }
  .ant-input-affix-wrapper {
    min-height: 50px;
    padding: 12px 15px;
    background: #fff;
    border: 1px solid #E3E6EF;
    border-radius: 10px;
    transition: 0.2s;
    box-shadow: 0 2px 3px rgba(24, 33, 57, 0.015);
  }
  .ant-input {
    color: #272B41;
    font-size: 13px;
    background: transparent;
  }
  .ant-input::placeholder {
    color: #ADB4C8;
  }
  .ant-input-prefix {
    color: #868EAE;
    margin-right: 11px;
    font-size: 15px;
  }
  .ant-input-affix-wrapper:hover {
    border-color: #9295F6;
  }
  .ant-input-affix-wrapper-focused {
    border-color: #5F63F2;
    box-shadow: 0 0 0 3px #5F63F212;
  }
  .ant-input-password-icon {
    color: #868EAE;
  }
  .login-form-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 0 0 27px;
    font-size: 12px;
  }
  .login-form-options label {
    font-size: 12px;
    color: #5A5F7D;
  }
  .login-form-options a {
    color: #5F63F2;
    font-size: 12px;
    font-weight: 500;
  }
  .login-submit.ant-btn {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #5F63F2;
    background: #5F63F2;
    font-size: 13px;
    font-weight: 600;
    box-shadow: 0 5px 12px #5F63F224;
  }
  .login-submit.ant-btn:hover {
    background: #4D50D9;
    border-color: #4D50D9;
    transform: translateY(-1px);
  }
  .login-submit .submit-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
  }
  .signup-terms {
    margin: 0 0 24px;
  }
  .signup-terms label {
    font-size: 11px;
    color: #868EAE;
    line-height: 1.8;
    display: flex;
    align-items: flex-start;
  }
  .signup-terms .ant-checkbox {
    top: 4px;
  }
  .auth-return {
    text-align: center;
    margin: 24px 0 0;
    font-size: 12px;
  }
  .auth-return a {
    color: #5F63F2;
  }
  .auth-help {
    font-size: 11px;
    color: #868EAE;
    text-align: center;
    margin-top: 20px;
  }
  .auth-next-steps {
    padding: 18px 22px 18px 38px;
    margin: 0 0 26px;
    background: #F4F5F7;
    border: 1px solid #E3E6EF;
    border-radius: 12px;
    color: #5A5F7D;
    font-size: 12px;
    line-height: 2.4;
  }
  .login-privacy-note {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    color: #868EAE;
    font-size: 11px;
    margin: 24px 0 0;
  }
  .login-panel-footer {
    text-align: center;
    color: #868EAE;
    font-size: 10px;
    letter-spacing: 0.2px;
  }
  .login-mobile-brand {
    display: none;
  }
  a:focus-visible,
  button:focus-visible {
    outline: 2px solid #5F63F2;
    outline-offset: 4px;
  }
  @media (min-width: 1600px) {
    .login-story {
      padding: 52px 80px;
    }
  }
  @media (max-width: 1100px) {
    .login-story {
      padding: 36px;
    }
    .login-panel {
      padding: 36px;
    }
    .story-main h1 {
      font-size: 40px;
    }
    .conversation-scene {
      padding: 18px;
    }
    .story-footer {
      flex-wrap: wrap;
      line-height: 1.8;
    }
  }
  @media (min-width: 768px) and (max-height: 820px) {
    .login-story {
      padding: 28px 40px;
    }
    .story-main {
      margin: 24px auto;
      max-width: 490px;
    }
    .story-main h1 {
      font-size: 38px;
      letter-spacing: -1.3px;
      margin-bottom: 16px;
    }
    .story-eyebrow {
      margin-bottom: 16px;
    }
    .story-description {
      line-height: 1.7;
      margin-bottom: 24px;
      font-size: 13px;
    }
    .conversation-scene {
      padding: 16px;
    }
    .scene-header {
      padding-bottom: 12px;
      margin-bottom: 14px;
    }
    .message-example {
      padding: 10px 12px;
      font-size: 11px;
      line-height: 1.7;
    }
    .message-example.reply {
      margin-top: 10px;
    }
    .scene-agent {
      margin-top: 12px;
    }
    .channel-tags {
      margin-top: 14px;
    }
    .login-form-area {
      padding: 28px 0;
    }
    .login-form-mark {
      margin-bottom: 22px;
    }
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    .login-story {
      display: none;
    }
    .login-panel {
      min-height: 100vh;
      min-height: 100dvh;
      padding: 28px 24px 22px;
    }
    .login-mobile-brand {
      display: block;
      margin-bottom: 22px;
    }
    .login-mobile-brand img {
      width: 132px;
      height: 38px;
      object-fit: cover;
      object-position: center;
    }
    .login-topline {
      justify-content: flex-start;
    }
    .login-form-area {
      padding: 40px 0;
    }
    .login-form-area h2 {
      font-size: 32px;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      transition: none !important;
    }
  }
`;

export default SignInScreen;
